import { QuestionIds } from 'onboarding/data/constants/QuestionIds';

export enum QuestionTypes {
  Option,
  Color,
  Places,
  Info,
  Custom,
  Optional,
  Statement,
  Image,
  Blitz,
  EduAnswer,
  LivenStatement,
  LivenOption,
}

export abstract class Question {
  id: QuestionIds;
  variationId: QuestionIds;
  type: QuestionTypes;
  hasStepper: boolean;
  hasHeader?: boolean;

  protected constructor(
    type: QuestionTypes,
    id: QuestionIds,
    hasStepper: boolean,
    hasHeader?: boolean,
    variationId?: QuestionIds,
  ) {
    this.type = type;
    this.id = id;
    this.hasStepper = hasStepper;
    this.variationId = variationId ?? id;
    this.hasHeader = hasHeader;
  }
}

export class CustomQuestion extends Question {
  constructor(
    id: QuestionIds,
    hasStepper = false,
    hasHeader = false,
    variationId?: QuestionIds,
  ) {
    super(QuestionTypes.Custom, id, hasStepper, hasHeader, variationId);
  }
}
